import { jsx } from "react/jsx-runtime";
import React from "react";
import { createPortal } from "react-dom";
function Portal({
  children,
  className = "bynder-design-system-portal"
}) {
  const mountNode = React.useRef(null);
  const portalNode = React.useRef(null);
  const forceUpdate = useForceUpdate();
  React.useLayoutEffect(() => {
    if (!mountNode.current) {
      return;
    }
    const ownerDocument = mountNode.current.ownerDocument;
    portalNode.current = ownerDocument == null ? void 0 : ownerDocument.createElement("div");
    portalNode.current.classList.add(className);
    ownerDocument == null ? void 0 : ownerDocument.body.appendChild(portalNode.current);
    forceUpdate();
    return () => {
      var _a;
      if ((_a = portalNode == null ? void 0 : portalNode.current) == null ? void 0 : _a.ownerDocument) {
        portalNode.current.remove();
      }
    };
  }, [className, forceUpdate]);
  return portalNode.current ? createPortal(children, portalNode.current) : /* @__PURE__ */ jsx("span", {
    ref: mountNode
  });
}
function useForceUpdate() {
  const [, dispatch] = React.useState(/* @__PURE__ */ Object.create(null));
  return React.useCallback(() => {
    dispatch(/* @__PURE__ */ Object.create(null));
  }, []);
}
export {
  Portal
};
//# sourceMappingURL=Portal.js.map
